module.exports = __webpack_public_path__ + "static/media/IMG_1271.ceeade55.jpg";